import axios from "axios";
// config
import { HOST_API_KEY, REFRESH_TOKEN_ENABLE } from "../config-global";
import { setSession, tokenExpired } from "../auth/context/jwt/utils";

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API_KEY });
//// it works
// https.globalAgent.options.rejectUnauthorized = false;

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    try {
      if (error.response.status === 401) {
        if (REFRESH_TOKEN_ENABLE === "true") {
          return callAgain(error);
        } else {
          setSession(null, null);
          tokenExpired();
        }
      }
      return Promise.reject(
        (error.response && error.response.data) || "Something went wrong"
      );
    } catch (e) {
      return Promise.reject(
        (e.response && e.response.data) || "Something went wrong"
      );
    }
  }
);

/**
 * Performs an asynchronous request using Axios, with the ability to refresh the access token if it has expired.
 *
 * @param {any} error - The error object received from a previous failed request.
 * @returns {Promise<any>} - A promise that resolves to the response data of the successful request, or rejects with an error message.
 */

async function callAgain(error: any) {
  try {
    try {
      const refreshToken = localStorage.getItem("refreshToken") || "";
      const res = await axios.post(
        `/api/v1/auth/refresh/createAccessToken`,
        {},
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${refreshToken}`,
          },
        }
      );
      setSession(res?.data?.accessToken, refreshToken);
    } catch (e) {
      if (e.response.status === 401) {
        setSession(null, null);
        tokenExpired();
      }
      return Promise.reject(
        (e.response && e.response.data) || "Something went wrong"
      );
    }
    const accessToken = localStorage.getItem("accessToken") || "";
    return axiosInstance.request({
      ...error.config,
      headers: {
        ...error.config.headers,
        Authorization: `Bearer ${accessToken}`,
      },
    });
  } catch (e) {
    return Promise.reject(
      (e.response && e.response.data) || "Something went wrong"
    );
  }
}

export default axiosInstance;
